import { Container } from '~/components/ui/Container'
import { getMallCategoryList_marketingModule_categoryList } from '~/graphqls/types'
import Link from 'next/link'
import { MyImage } from '~/components/ui/MyImage'

export const Category: React.FC<{
  data: getMallCategoryList_marketingModule_categoryList[]
}> = ({ data }) => {
  return (
    <section>
      <Container>
        <div className="flex justify-between items-center pt-4 pb-14">
          {data.map(it => (
            <div key={it.id} className="w-24">
              <Link href={`/mall/category?id=${it.id}`} passHref>
                <a>
                  <MyImage
                    tag="v400"
                    style={{ width: 55, height: 55 }}
                    src={it.image}
                    className="mx-auto mb-2 rounded-full"
                  />
                  <div className="text-sm text-neutral-100 text-center line-clamp-1">
                    {it.name}
                  </div>
                </a>
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
